var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"center-frame",attrs:{"id":"galaxy_visualization","src":_setup.srcWithRoot,"frameborder":"0","title":"galaxy visualization frame","width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }